import React from 'react';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig } from '../util';
import { getMailFromMails } from '@web-mail/util';
const ReadMailIconMenuRightConfig = [
    {
        key: MAIL_MENU_ITEM.WMFOLLOW,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.RED_FLAG,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.TAG,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL,
        group: '1',
    },
    {
        key: 'extend',
        group: '1',
        icon: React.createElement(ReadListIcons.MoreSvg_Cof, null),
        show: (mails) => {
            const mail = getMailFromMails(mails);
            return true;
        },
        subMenus: [],
    },
];
export default findAndMergeDefaultMenuConfig(ReadMailIconMenuRightConfig, DefaultMailMenuConfig);
